import { type CanvasEventTarget, isEventTarget } from './event-targets';

export const element = (input: unknown): HTMLElement | SVGElement | undefined =>
  input instanceof HTMLElement || input instanceof SVGElement ? input : undefined;

export const getCanvasTargetFromDOM = (
  target: EventTarget,
): CanvasEventTarget | undefined => {
  const canvasTarget = element(target)
    ?.closest('[data-canvas-target]')
    ?.getAttribute('data-canvas-target');

  if (isEventTarget(canvasTarget)) {
    return canvasTarget;
  }

  return undefined;
};

export const getEntityIdFromDOM = (target: EventTarget): string | undefined => {
  const canvasEntityId = element(target)
    ?.closest('[data-canvas-target]')
    ?.getAttribute('data-entity-id');

  return canvasEntityId ?? undefined;
};
